/** @file Window blur: forget modifiers and release every held key so nothing stays stuck. */
import { keyState } from './keyState';
import { releaseAll } from './releaseAll';

/** Keys released while the window is unfocused never send keyup, so treat blur as releasing everything. */
export function handleBlur(): void {
  Object.assign(keyState.modifiers, { ctrl: false, meta: false, shift: false, alt: false, mod: false });
  releaseAll();
}
